export default __webpack_public_path__ + "static/garden_design22-8f03e2ef6605cc76773a254f32724f61.webp";